import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import "./Carousel.scss";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import LikeIcon from "../../../assets/icons/like-icon-small.svg";
import LikedIcon from "../../../assets/icons/liked-icon-small.svg";
import store from "../../../store";


interface CarouselImage {
  url: string;
  mediaType?: string;
  mediaSubType?: string;
}

interface CarouselComponentProps {
  images: CarouselImage[];
  avgRating?: number;
  isFavorite?: boolean;
  onFavoriteToggle?: () => void;
  view?: "grid" | "list";
  showFavoriteIcon?: boolean;
}

const CarouselComponent: React.FC<CarouselComponentProps> = ({
  images,
  avgRating = 0,
  view,
  isFavorite,
  onFavoriteToggle,
  showFavoriteIcon,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  if (!images || images.length === 0) {
    return null;
  }
  const isLoggedIn = store.getState()?.session?.isLoggedIn || false;


  const safeIndex =
    currentIndex < 0 || currentIndex >= images.length ? 0 : currentIndex;

  const currentImage = images[safeIndex];
  if (!currentImage || !currentImage.url) {
    return null;
  }
  const prevImage = () => {
    if (currentIndex === 0) return;
    setCurrentIndex(currentIndex - 1);
  };

  const nextImage = () => {
    if (currentIndex === images.length - 1) return;
    setCurrentIndex(currentIndex + 1);
  };

  return (
    <Box className={`carousel carousel--${view || "list"}`}>
      {/* Top Left: Rating */}
      <Box className="carousel__top-left">
        {avgRating && <StarRoundedIcon
          fontSize="small"
          sx={{
            color: "#e9ae10",
          }}
        />}
        <Typography variant="body2">
          {avgRating !== null && avgRating !== undefined
            ? avgRating.toFixed(1)
            : ""}
        </Typography>
      </Box>

      {/* {isLoggedIn && showFavoriteIcon && (
        <>
          {isFavorite ? (
            <Box
              className="carousel__top-right"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 1)",
                borderRadius: "8px !important",
                width: "25px",
                height: "25px",
                padding: "3px 2px 2px 3px",
              }}
            >
              <IconButton onClick={onFavoriteToggle}>
                <img src={LikedIcon} alt="wishlist icon" />
              </IconButton>
            </Box>
          ) : (
            <Box
              className="carousel__top-right"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                padding: "2px",
              }}
            >
              <IconButton onClick={onFavoriteToggle}>
                <img src={LikeIcon} alt="wishlist icon" />
              </IconButton>
            </Box>
          )}
        </>
      )} */}

      {/* Left Arrow */}
      <IconButton
        className={`carousel__arrow carousel__arrow--left ${currentIndex === 0 ? "carousel__arrow--disabled" : ""
          }`}
        onClick={prevImage}
        disabled={currentIndex === 0}
      >
        <ArrowBackIos fontSize="small" />
      </IconButton>
      {/* Right Arrow */}
      <IconButton
        className={`carousel__arrow carousel__arrow--right ${currentIndex === images.length - 1 ? "carousel__arrow--disabled" : ""
          }`}
        onClick={nextImage}
        disabled={currentIndex === images.length - 1}
      >
        <ArrowForwardIos fontSize="small" />
      </IconButton>

      {/* Media Rendering */}
      {images[currentIndex].mediaType === "video" ? (
        <video
          src={images[currentIndex].url}
          className="carousel__image"
          controls
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          src={images[currentIndex].url}
          alt={`carousel-${currentIndex}`}
          className="carousel__image"
        />
      )}

      {/* Bottom Right: Image Count */}
      <Box className="carousel__bottom-right">
        <Typography className="carousel__bottom-right-text">
          {currentIndex + 1} of {images.length}
        </Typography>
      </Box>
    </Box>
  );
};

export default CarouselComponent;
